<template>
  <nav>
    <v-row class="w-100 align-center loginBackground justify-center">
      <v-alert
        v-if="alertMsg != ''"
        type="error"
        class="rounded-xxl mb-8 text-left"
        max-width="600"
        min-width="300"
      >
        {{ $t(alertMsg) }}
      </v-alert>
    </v-row>
    <v-row class="fill-height loginBackground" align="center">
      <v-col
        cols="12"
        sm="8"
        md="6"
        offset-sm="2"
        offset-md="3"
        align="center"
      >
        <v-progress-circular
          v-if="!success"
          :size="125"
          :width="7"
          indeterminate
          class="my-16"
          color="accent"
        />

        <v-icon
          v-if="success"
          color="success"
          size="x-large"
          style="font-size: 128px"
          >mdi-checkbox-marked-circle-outline</v-icon
        >
      </v-col>
    </v-row>
  </nav>
</template>
<script>
import i18n from '../../plugins/i18n'
import { setFortnoxAuthToken } from "../../api/fortnoxApi";

export default {
  components: {},
  data() {
    return {
      alertType: "",
      alertMsg: "",
      fortnoxCallback: false,
      loadingData: false,
      success: false,
    };
  },

  async created() {
    this.loadingData = true;

    let queryString = window.location.search;
    let urlParams = new URLSearchParams(queryString);
   
    let fortnoxAuthCode = urlParams.get("code");
    if (fortnoxAuthCode) {
      this.fortnoxCallback = true;
      await this.setFortnoxAuthToken(fortnoxAuthCode);
    } else {
      this.fortnoxCallback = false;
      this.alertType = "error";
      this.alertMsg = "Invalid or missing Authorization Code";
    }
    this.loadingData = false;
  },

  methods: {
    async setFortnoxAuthToken(fortnoxAuthCode) {
      if (window.$cookies.get("fortnoxId")) {
        var integrationId = window.$cookies.get("fortnoxId");

        try {
          const response = await setFortnoxAuthToken(
            integrationId,
            fortnoxAuthCode
          );
          if (response.status == 200) {
            if (response.data.meta.status == "success") {
              this.success = true;
              setTimeout(() => {
                window.close(); // Close the current tab
              }, 3000);
            }
          }
        } catch (e) {
          if (e.response) {
            this.fortnoxCallback = false;
            this.alertType = "error";
            this.alertMsg = e.response.data.errors[0].detail;
          }
        }
      } else {
        this.fortnoxCallback = false;
        this.alertType = "error";
        this.alertMsg = i18n.t("invalidIntegration")
      }
    },
  },
};
</script>
